import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { BookOpen, Eye, ArrowRight, Loader2 } from 'lucide-react';
import { Badge } from '../components/ui/badge';

const API = process.env.REACT_APP_BACKEND_URL;

export default function BlogPage() {
  const { t } = useLanguage();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/blog`).then(r => r.json()).then(d => { setPosts(d.posts || []); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-32"><Loader2 className="h-8 w-8 animate-spin text-[#00E5FF]" /></div>;

  return (
    <div className="px-6 md:px-12 max-w-7xl mx-auto py-12 md:py-20" data-testid="blog-page">
      <div className="mb-12">
        <div className="flex items-center gap-3 mb-2">
          <BookOpen className="h-6 w-6 text-[#00E5FF]" />
          <h1 className="text-4xl md:text-5xl font-bold text-white font-['Outfit'] tracking-tight">{t('services.blog')}</h1>
        </div>
        <p className="text-zinc-500">Insights, trends, and guides from the domain industry</p>
      </div>

      {posts.length === 0 ? (
        <div className="text-center py-20 bg-[#0A0A0A] border border-white/5 rounded-sm">
          <BookOpen className="h-12 w-12 text-zinc-700 mx-auto mb-4" />
          <p className="text-zinc-500">No blog posts yet. Check back soon!</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="blog-grid">
          {posts.map((post, i) => (
            <Link key={post.id} to={`/blog/${post.id}`}
              className="block bg-[#0A0A0A] border border-white/5 hover:border-[#00E5FF]/30 rounded-sm overflow-hidden group transition-all" data-testid={`blog-post-${post.id}`}>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <Badge variant="outline" className="text-[10px] uppercase tracking-widest border-zinc-700 text-zinc-500">{post.category}</Badge>
                  <div className="flex items-center gap-1 text-[10px] text-zinc-600">
                    <Eye className="h-3 w-3" /> {post.views || 0}
                  </div>
                </div>
                <h2 className="text-xl font-bold text-white group-hover:text-[#00E5FF] transition-colors font-['Outfit'] mb-2">{post.title}</h2>
                <p className="text-sm text-zinc-500 line-clamp-3">{post.excerpt}</p>
                <div className="mt-4 flex items-center gap-1 text-xs text-[#00E5FF] uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity">
                  Read more <ArrowRight className="h-3 w-3" />
                </div>
              </div>
              <div className="px-6 py-3 border-t border-white/5 flex items-center justify-between">
                <span className="text-[10px] text-zinc-600">{post.author}</span>
                <span className="text-[10px] text-zinc-600">{new Date(post.created_at).toLocaleDateString()}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
